<!-- Wrapper -->
<div class="flex flex-col w-full h-full max-w-full max-h-full min-w-0">
  <!-- Header -->
  <div style="background: #2b385d 0% 0% no-repeat padding-box !important"
    class="relative flex items-center w-full px-4 shadow h-18 flex-0 md:px-6 z-49 dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
    <!-- Navigation toggle button -->
    <!-- <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon
                class="text-white"
                [svgIcon]="'heroicons_outline:menu'"
            ></mat-icon>
        </button> -->

    <button class="inline-flex" mat-icon-button (click)="toggleNavigationAppearance()">
      <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
    </button>

    <img class="ml-2 w-30" src="assets/images/logo/logo-piima.svg" alt="Logo image" />
    <!-- Components -->
    <div class="flex items-center pl-2 ml-auto space-x-1 sm:space-x-2">
      <!-- <app-dark-mode-switcher></app-dark-mode-switcher> -->
      <languages></languages>
      <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
      <!-- <search [appearance]="'bar'"></search> -->
      <!-- <messages></messages> -->
      <!-- <notifications></notifications> -->
      <user></user>
    </div>
  </div>

  <div class="flex flex-row flex-auto max-h-full overflow" style="height: calc(100% - 72px) !important">
    <!-- Navigation -->
    <fuse-vertical-navigation style="background: #3b4c7e 0% 0% no-repeat padding-box !important"
      class="bg-nav dark print:hidden" [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'"
      [appearance]="navigationAppearance" [navigation]="navigation.default" [opened]="opened"
      (openedChanged)="opened = $event">
      <!-- [opened]="!isScreenSmall" -->
      <!-- Navigation header hook -->
      <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex items-center h-20 p-6 pb-0">
          <!-- Light version -->
          <img class="dark:hidden w-30" src="assets/images/logo/logo-text.svg" alt="Logo image" />
          <!-- Dark version -->
          <img class="hidden dark:flex w-30" src="assets/images/logo/logo-text-on-dark.svg" alt="Logo image" />
        </div>
      </ng-container>
    </fuse-vertical-navigation>

    <div class="flex flex-col flex-auto w-full max-h-full min-w-0">
      <router-outlet *ngIf="true"></router-outlet>
    </div>
  </div>
  <footer class="sliding-footer" [class.hidden]="isFooterHidden">
    <div class="footer-content">
      <div>
        <img src="../../../../../assets/icons/redesign-icons/uzinfocom.svg" alt="" />
      </div>
      <div>© 2025</div>
    </div>
  </footer>
</div>